import type { PurchaseOrder } from "@shared/types";
import type { HeaderContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

/**
 * OrderHeaderCell
 *
 * Renders just the column label text.
 * Sort interaction (button wrapper, sort indicator icon) is handled by
 * DataTableHeader → HeaderCell in data-table-header.tsx.
 */
export const OrderHeaderCell = <TData extends PurchaseOrder>(props: HeaderContext<TData, unknown> | undefined) => {
  const { t } = useTranslation();
  const headerId = props?.header.id;

  return <span className="text-sm font-medium">{t(`views.orders.columns.${headerId}`)}</span>;
};
